module.exports = __webpack_public_path__ + "media/images/checkStatus-Complete-72948d9f.png";